import { render } from "./LoginModalComponent.vue?vue&type=template&id=c15d808c"
import script from "./LoginModalComponent.vue?vue&type=script&lang=ts"
export * from "./LoginModalComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script